enum Size {
  sm = 'small',
  small = 'small',
  md = 'medium',
  medium = 'medium',
  xl = 'large',
  large = 'large'
}

export default Size
